import { render, staticRenderFns } from "./comp_programList.vue?vue&type=template&id=6370e2d2&scoped=true"
import script from "./comp_programList.vue?vue&type=script&lang=js"
export * from "./comp_programList.vue?vue&type=script&lang=js"
import style0 from "./comp_programList.vue?vue&type=style&index=0&id=6370e2d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6370e2d2",
  null
  
)

export default component.exports